"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _layout = _interopRequireDefault(require("@clayui/layout"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _warning = _interopRequireDefault(require("warning"));

var _Header = _interopRequireDefault(require("./Header"));

var _Item = _interopRequireDefault(require("./Item"));

var _ItemText = _interopRequireDefault(require("./ItemText"));

var _ItemTitle = _interopRequireDefault(require("./ItemTitle"));

var _QuickActionMenu = _interopRequireDefault(require("./QuickActionMenu"));

var _excluded = ["children", "className", "showQuickActionsOnHover"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CLAY_REGEX = /Clay(?!ListItem|ListHeader).+/;

function ClayList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$showQuickActions = _ref.showQuickActionsOnHover,
      showQuickActionsOnHover = _ref$showQuickActions === void 0 ? true : _ref$showQuickActions,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("ul", _extends({}, otherProps, {
    className: (0, _classnames.default)('list-group', className, {
      'show-quick-actions-on-hover': showQuickActionsOnHover
    })
  }), "production" !== 'development' && children, "production" === 'development' && children && _react.default.Children.map(children, function (child) {
    "production" !== "production" ? (0, _warning.default)(!(child && // @ts-ignore
    child.type.displayName && // @ts-ignore
    child.type.displayName.match(CLAY_REGEX)), // @ts-ignore
    "Direct descendant of ClayList must be either ClayList.Item or ClayList.Header. You used ".concat(child.type.displayName, ".")) : void 0;
    return child;
  }));
}

ClayList.displayName = 'ClayList';
ClayList.Header = _Header.default;
ClayList.Item = _Item.default;
ClayList.ItemField = _layout.default.ContentCol;
ClayList.ItemText = _ItemText.default;
ClayList.ItemTitle = _ItemTitle.default;
ClayList.QuickActionMenu = _QuickActionMenu.default;
var _default = ClayList;
exports.default = _default;